import {
  ClientCodeRequest,
  ProblemDetails,
  Profile,
  ProspectCodeRequest
} from '@shared/webapi/MIF.Subscription.WebApi';

export type ClientAuthRequest = ClientCodeRequest | ProspectCodeRequest;

export enum ClientAuthErrorCode {
  InvalidCredentials = 'InvalidCredentials',
  InvalidCodeOrSessionId = 'InvalidCodeOrSessionId',
  AccessBlocked = 'AccessBlocked',
  CodeDeliveryFailed = 'CodeDeliveryFailed',
  TooManyRequests = 'TooManyRequests'
}

export enum ClientType {
  Contract = 'Contract',
  Prospect = 'Prospect'
}

export enum ClientAuthorizationStatus {
  Idle = 'Idle',
  PendingOtp = 'PendingOtp',
  Authorizing = 'Authorizing',
  Authorized = 'Authorized',
  Unauthorized = 'Unauthorized',
  Blocked = 'Blocked'
}

export interface ClientAuthError {
  detail: string | null;
  errorCode: ClientAuthErrorCode | null;
  status: number | null;
  title: string | null;
}

export interface RequestCodeClientAuthError extends ClientAuthError {
  lockoutEnd: string | null;
  remainingAttempts: null;
}

export interface ValidateCodeClientAuthError extends ClientAuthError {
  lockoutEnd: string | null;
  remainingAttempts: number | null;
}

export interface AuthorizedClientContext {
  profile: Profile | null;
  status: ClientAuthorizationStatus;
}

export interface RequestCodeClientProblemDetails extends ProblemDetails {
  errorCode?: string;
  lockoutEnd?: string;
  remainingAttempts?: number;
}
